import { history } from "instantsearch.js/es/lib/routers";

const refinementKeyMapping = {
  brand: "brand",
  filterSizesClothing: "clothingSize",
  filterSizesShoe: "shoeSize",
  filterSizesTrouser: "trouserSize",
  filterColor: "color",
};

const hierarchicalMenuKeyMapping = {
  "categories.lvl0": "category",
};

const passthroughQueryParams = [
  "products",
  "cjevent",
  "cjUpSellitTest",
  "_kx",
  "utm_source",
  "utm_medium",
  "utm_term",
  "utm_content",
  "utm_campaign",
  "mc_cid",
  "mc_eid",
  "gclid",
  "gad_source",
  "_gl",
  "epik",
  "fbclid",
  "ttclid",
  "msclkid",
];

const GetPassthroughRouteState = () => {
  const urlParams = new URL(window.location.href).searchParams;

  return passthroughQueryParams.reduce((acc, key) => {
    const values = urlParams.getAll(key);
    if (values.length === 1) {
      acc[key] = values[0];
    } else if (values.length > 1) {
      acc[key] = values;
    }

    return acc;
  }, {});
};

const RouteToState = (
  routeState: any,
  indexName: string,
  prefix: string,
  categoryPageId?: string
) => {
  const partRefinementList = Object.entries(refinementKeyMapping).reduce(
    (acc, [key, value]) => {
      acc[key] = routeState[`${prefix}${value}`];
      return acc;
    },
    {}
  );
  const partCategoryPageId =
    categoryPageId !== undefined ? { categoryPageId: [categoryPageId] } : {};
  const partHierarchicalMenu = Object.entries(
    hierarchicalMenuKeyMapping
  ).reduce((acc, [key, value]) => {
    acc[key] = routeState[`${prefix}${value}`];
    return acc;
  }, {});

  const sortBy =
    routeState.sortBy === ""
      ? window.__litium.algoliaSettings.indexName
      : routeState.sortBy === undefined
      ? null
      : window.__litium.algoliaSettings.indexName + "_" + routeState.sortBy;

  return {
    [indexName]: {
      query: routeState[`${prefix}q`],
      page: routeState[`${prefix}page`],
      refinementList: {
        ...partRefinementList,
        ...partCategoryPageId,
      },
      hierarchicalMenu: { ...partHierarchicalMenu },
      sortBy: sortBy,
    },
  };
};

const GetInitialRouteState = () => {
  const urlParams = new URL(window.location.href).searchParams;
  let paramsObject = {};
  urlParams.forEach((value, key) => {
    const matches = key.match(/^(.+)\[[\d]+\]/);
    if (matches && matches.length > 1) {
      const arrayKey = matches[1];
      if (paramsObject[arrayKey]) {
        paramsObject[arrayKey].push(value);
      } else {
        paramsObject[arrayKey] = [value];
      }
    } else {
      paramsObject[key] = value;
    }
  });

  return paramsObject;
};

export const InitialUiState = (
  indexName: string,
  routingPrefix: string,
  categoryPageId?: string
) => {
  const routeState = GetInitialRouteState();
  return RouteToState(routeState, indexName, routingPrefix, categoryPageId);
};

const StateMapping = (
  indexName: string,
  prefix: string,
  categoryPageId?: string
) => {
  return {
    stateToRoute(uiState) {
      const indexUiState = uiState[indexName];
      const partQuery = {
        [`${prefix}q`]: indexUiState.query,
        [`${prefix}page`]: indexUiState.page,
      };
      const partRefinementList = Object.entries(refinementKeyMapping).reduce(
        (acc, [key, value]) => {
          acc[`${prefix}${value}`] =
            indexUiState.refinementList && indexUiState.refinementList[key];
          return acc;
        },
        {}
      );
      const partHierarchicalMenu = Object.entries(
        hierarchicalMenuKeyMapping
      ).reduce((acc, [key, value]) => {
        acc[`${prefix}${value}`] =
          indexUiState.hierarchicalMenu && indexUiState.hierarchicalMenu[key];
        return acc;
      }, {});
      const sortBy = indexUiState.sortBy || indexName;
      const suffix =
        sortBy.startsWith(window.__litium.algoliaSettings.indexName) &&
        sortBy.length > window.__litium.algoliaSettings.indexName.length
          ? sortBy.slice(window.__litium.algoliaSettings.indexName.length + 1)
          : indexName === window.__litium.algoliaSettings.indexName
          ? undefined
          : "";

      return {
        ...GetPassthroughRouteState(),
        ...partQuery,
        ...partRefinementList,
        ...partHierarchicalMenu,
        sortBy: suffix,
      };
    },
    routeToState(routeState) {
      return RouteToState(routeState, indexName, prefix, categoryPageId);
    },
  };
};

export const Routing = (
  indexName: string,
  routingPrefix: string,
  categoryPageId?: string
) => {
  return {
    router: history({
      cleanUrlOnDispose: false,
      push(url) {
        const newUrl = url
          .replace(/(%..)/g, (match) => match.toLowerCase())
          .replace(/%20/g, "+");
        window.history.replaceState({}, "", newUrl);
      },
    }),
    stateMapping: StateMapping(indexName, routingPrefix, categoryPageId),
  };
};
